function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import cn from 'classnames';
import map from 'lodash/map';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import App from 'modules/App';
import X from 'svg/x.svg';
import { formatLocalizationResource } from 'helpers/i18n';
import { useAction } from 'hooks';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from '../NotificationsPopover.pcss';
import { Loader, NoNotifications } from './renderers';
import useLinkRendereres from './useLinkRendereres';
import Actions from './Actions';
const NotificationsList = ()=>{
    useStyles(styles);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const notificationsRecordsGrouped = useSelector(selectors.notificationsRecordsGrouped);
    const notificationsRecords = useSelector(selectors.notificationsRecords);
    const isInProgress = useSelector(selectors.isFetchNotificationsInProgress);
    const dismissNotification = useAction(actions.dismissNotification);
    const linkRenderers = useLinkRendereres();
    const dismissNotificationClick = (evt, notification)=>{
        evt.preventDefault();
        dismissNotification(notification);
    };
    const renderDismissNotification = (notification)=>{
        if (notification.status === 'Dismissed') return null;
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            "aria-label": "Dismiss",
            className: styles.notifications__notification__dismiss,
            onClick: (evt)=>dismissNotificationClick(evt, notification),
            children: /*#__PURE__*/ _jsx("span", {
                className: "btn-inner",
                children: /*#__PURE__*/ _jsx(X, {
                    className: styles.notifications__notification__dismiss__icon
                })
            })
        });
    };
    const renderNotification = (notification)=>{
        const message = formatLocalizationResource(localizationResources, notification.resourceKey, notification.variables, linkRenderers);
        return /*#__PURE__*/ _jsxs(motion.li, {
            initial: {
                height: 0
            },
            animate: {
                height: 'auto'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.3
            },
            className: cn(styles.notifications__notification, {
                [styles['notifications__notification--active']]: notification.status === 'Active',
                [styles['notifications__notification--dismissed']]: notification.status === 'Dismissed',
                [styles['notifications__notification--read']]: notification.status === 'Read'
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `align-items-center ${styles.notifications__notification__inner}`,
                    children: /*#__PURE__*/ _jsx("div", {
                        children: message
                    })
                }),
                renderDismissNotification(notification)
            ]
        }, notification.instantNotificationId);
    };
    const renderNotificationsGroup = (notificationsGroup, name)=>{
        if (!notificationsGroup.length) return null;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.notificationsGroup,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.notificationsGroup__header,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.listTimelines[name]))
                }),
                map(notificationsGroup, renderNotification)
            ]
        }, name);
    };
    if (!notificationsRecords || !notificationsRecords.length) {
        if (isInProgress) {
            return /*#__PURE__*/ _jsx(Loader, {});
        }
        return /*#__PURE__*/ _jsx(NoNotifications, {});
    }
    const orderedTimelines = [
        'today',
        'yesterday',
        'thisWeek',
        'older'
    ];
    return /*#__PURE__*/ _jsx("div", {
        className: styles.notifications__list,
        "data-testid": "notifications-list",
        children: /*#__PURE__*/ _jsxs(AnimatePresence, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.notificationsGroups,
                    children: map(orderedTimelines, (timeLine)=>renderNotificationsGroup(notificationsRecordsGrouped[timeLine], timeLine))
                }, "notificationsGroups"),
                /*#__PURE__*/ _jsx(Actions, {}, "actions")
            ]
        })
    });
};
export default NotificationsList;
